import ClipperLib from 'clipper-lib';
import { dividerLines } from './dividerLayout';
import { clipPath, fixedGlassOutline } from './windowShapes';

// Shared pure geometry used by the 3D builder and numeric boundary tests.
export function clippedGrillePaths(design) {
  const t = design.dividers.bar_width_in * .0254;
  const glass = fixedGlassOutline(design);
  if (glass.length < 3) return [];
  const xs = glass.map(p => p[0]), ys = glass.map(p => p[1]), left = Math.min(...xs), bottom = Math.min(...ys), width = Math.max(...xs) - left, height = Math.max(...ys) - bottom;
  const paths = dividerLines(design.dividers).map(line => {
    const x1 = left + line.x1 * width, y1 = bottom + line.y1 * height, x2 = left + line.x2 * width, y2 = bottom + line.y2 * height;
    const horizontal = line.y1 === line.y2;
    const x = horizontal ? x1 : x1 - t / 2, y = horizontal ? y1 - t / 2 : y1;
    const barWidth = horizontal ? x2 - x1 : t, barHeight = horizontal ? t : y2 - y1;
    return clipPath([[x, y], [x + barWidth, y], [x + barWidth, y + barHeight], [x, y + barHeight]]);
  });
  if (!paths.length) return [];
  const clipper = new ClipperLib.Clipper(), clipped = [];
  clipper.AddPaths(paths, ClipperLib.PolyType.ptSubject, true); clipper.AddPath(clipPath(glass), ClipperLib.PolyType.ptClip, true);
  clipper.Execute(ClipperLib.ClipType.ctIntersection, clipped, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return clipped;
}